import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  list: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  subList: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  dialog: { visible: false, loading: false, type: '', title: '', data: null },
  confirm: { title: '', content: '', type: '', visible: false, loading: false },
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
